import { useEffect, useRef } from "react";
import Header from "./header";
import Benefits from "./benefits";
import BadgesCT from "./badgesCT";
import Challenges from "./challenges";
import Games from "./games";
import Play from "./play";
import Overview from "./overview";
import Wallet from "./wallet";
import "../assets/css/memberhub.css";
import { BrowserRouter as Router, Routes, Route, matchPath } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { validateUser, getBadgeById } from '../redux/data/dataActions';
import LoadingGif from "../assets/images/loading-gif-2.gif";
import { setTabSelected, setUserLoading } from "../redux/data/dataSlice";
import { setupMetaData } from "../utils/metaData";
import { injectMainScripts, injectUserConsent } from "../utils/loadScripts";

function MemHub() {
    const dispatch = useDispatch();
    const hasLoaded = useRef(false);
    const userLoading = useSelector(state => state.data.userLoading);
    const tabSelected = useSelector(state => state.data.tabSelected);

    useEffect(() => {
        console.log("MemHub: useEffect[]");

        const isCookieValid = async () => {
            console.log('validating-user-cookie');
            dispatch(validateUser(tabSelected));
        };

        isCookieValid();

        let fetchBadgeData = async (badgeId) => {
            if (badgeId) {
                let badge = await getBadgeById(badgeId);
                if (badge) {
                    let title = `NBA ID | Badges | ${badge.title}`;
                    let desc = badge.description;
                    let image = badge.image;
                    setupMetaData(title, desc, image);
                }
            }
        };

        let badgePath = matchPath('/badges/:badgeId', document.location.pathname);
        if (badgePath && badgePath.params && badgePath.params.badgeId) {
            fetchBadgeData(badgePath.params.badgeId);
        }

        let addUserConsent = true;
        let showHeaderFooter = true;
        if (matchPath('/play', document.location.pathname)) {
            showHeaderFooter = false;
            addUserConsent = false;
        } else {
            const queryParams = new URLSearchParams(window.location.search);
            const webview = queryParams.get("webview") ?? "false";
            if (webview && webview.toLowerCase() === "true") {
                showHeaderFooter = false;
            }
        }

        if (showHeaderFooter) {
            const nbaFooter = document.getElementById("nba-footer");
            if (nbaFooter) {
                nbaFooter.setAttribute("style", "position:relative;width:100%;padding-bottom:2rem;background-color:#000000;");
            }

            injectMainScripts();
        }

        if (addUserConsent) {
            injectUserConsent();
        }
    }, []);

    useEffect(() => {
        console.log("MemHub: useEffect[dispatch]");

        let isVotingTab = false;
        if (matchPath('/voting', document.location.pathname) || matchPath('/voting/:activityId', document.location.pathname)) {
            localStorage.setItem('fromVoting', '1');
            isVotingTab = true;
        }

        let newTab = "overview";

        if (matchPath('/overview', document.location.pathname)) {
            newTab = "overview";
        } else if (isVotingTab) {
            newTab = "voting";
        } else if (matchPath('/badges', document.location.pathname) || matchPath('/badges/:badgeId', document.location.pathname)) {
            newTab = "badges";
        } else if (matchPath('/benefits', document.location.pathname)) {
            newTab = "benefits";
        } else if (matchPath('/play', document.location.pathname)) {
            newTab = "play";
        } else if (matchPath('/challenges', document.location.pathname)) {
            newTab = "challenges";
        } else if (matchPath('/wallet', document.location.pathname)) {
            newTab = "wallet";
        }

        hasLoaded.current = true;

        console.log("memHub tabSelected:", newTab);
        dispatch(setTabSelected(newTab));

        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === "1") {
            dispatch(setUserLoading(false));
        }

    }, [dispatch]);

    useEffect(() => {
        console.log("MemHub: useEffect[dispatch, tabSelected]", tabSelected);

        // analytics variable
        if (hasLoaded.current) {
            let isVotingTab = false;
            if (matchPath('/voting', document.location.pathname) || matchPath('/voting/:activityId', document.location.pathname)) {
                localStorage.setItem('fromVoting', '1');
                isVotingTab = true;
            }

            if (matchPath('/wallet', document.location.pathname)) {
                localStorage.setItem('fromWallet', '1');
            }

            if (!isVotingTab && tabSelected !== "voting") {
                const isLoggedIn = localStorage.getItem('isLoggedIn');
                if (isLoggedIn === "1") {
                    dispatch(setUserLoading(false));
                } else {
                    dispatch(validateUser(tabSelected));
                }
            } else {
                dispatch(setUserLoading(false));
            }
        }
    }, [dispatch, tabSelected]);

    return (
        <Router>
            {userLoading ? (
                <div className="loading-container">
                    <div className="loading-gif">
                        <img src={LoadingGif} alt="" />
                    </div>
                </div>
            ) : (
                <>
                    <Header />
                    <div className={`memberhub-container ${tabSelected === "play" ? "embedded" : ""}`}>
                        <Routes>
                            <Route path="/" element={<Overview />} />
                            <Route path="/overview" element={<Overview />} />
                            <Route path="/benefits" element={<Benefits />} />
                            <Route path="/benefits/:rewardId" element={<Benefits />} />
                            <Route path="/voting" element={<Games />} />
                            <Route path="/voting/:activityId" element={<Games />} />
                            {/*<Route path="/badges" element={<Badges />} />
                            <Route path="/badges/:badgeId" element={<Badges />} />*/}
                            <Route path="/badges" element={<BadgesCT />} />
                            <Route path="/badges/:badgeId" element={<BadgesCT />} />
                            <Route path="/play" element={<Play />} />
                            <Route path="/play/:badgeId" element={<Play />} />
                            <Route path="/challenges" element={<Challenges />} />
                            <Route path="/challenges/:challengeId" element={<Challenges />} />
                            <Route path="/wallet" element={<Wallet />} />
                        </Routes>
                    </div>
                </>
            )}
        </Router>
    );
}

export default MemHub;
